import { render, staticRenderFns } from "./ViewOrganisation.vue?vue&type=template&id=5dc17dc6&scoped=true&"
import script from "./ViewOrganisation.vue?vue&type=script&lang=js&"
export * from "./ViewOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc17dc6",
  null
  
)

export default component.exports